/**
 * Permet de facilement ajouter des pages au router front
 * (cas de page demo / site sans craft etc)
 * 
 * !!! be carefull !!!
 * ces routes ne sont probablement pas dans craft
 * donc craft generera probablement des 404 en arriere
 * ! donc faites attention avec ca !
 */

export default [
  {
    "id": 1,
    "section": "home",
    "sites": [{
      "id": 1,
      "url": "",
      "slug": "home",
      "title": "home"
    }]
  },
  {
    "id": 2,
    "section": "bio",
    "sites": [{
      "id": 1,
      "url": "biographie/",
      "slug": "bio",
      "title": "Biographie"
    }]
  },
  {
    "id": 4,
    "section": "collection",
    "sites": [{
      "id": 1,
      "url": "collection/",
      "slug": "collection",
      "title": "La collection"
    }]
  },
  {
    "id": 5,
    "section": "credit",
    "sites": [{
      "id": 1,
      "url": "credits/",
      "slug": "credits",
      "title": "Crédits"
    }]
  },
  {
    "id": 6,
    "section": "thematique",
    "sites": [{
      "id": 1,
      "url": ":slug/",
      "slug": "thematique",
      "title": "Thematique"
    }]
  },
  {
    "id": 7,
    "section": "object",
    "sites": [{
      "id": 1,
      "url": ":thematique/:slug/",
      "slug": "object",
      "title": "object"
    }]
  },
]
